<ngx-loading [show]="loading" [config]="{ fullScreenBackdrop : true }"></ngx-loading>
   <div class="row" style="margin-top:10px">
       <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6" text-center style="margin-top:3px">
            <button class="btn btn-success btn-block " (click)="AddExistingUser()">Add Existing Patients</button>
       </div>
       <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6" text-center style="margin-top:3px">
            <button class="btn btn-success3 btn-block" (click)="sendNotification('all')">
                    Send Notification to All
                   </button>
      </div>
   </div>
  <div class="row"  style="margin-top:10px; margin-bottom:10px" *ngIf="myruserarray && shownormaldiv ">
      <div class="col-12" text-center>
        <h4><p style="color:#9b7544; overflow-wrap: break-word">
           <u>Your Registered Customers</u>  :({{myruserarray.length}}) Patients Found
        </p></h4>
      </div>
  </div>

  <div  *ngIf="shownormaldiv">
      <div class="row" *ngIf="myruserarray">
          <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4"  *ngFor="let data of myruserarray ">
                <mat-card >
                        <img md-card-image src="https://passport.petcart.in/images/userimgs/{{data.image}}" style="width:100% ; max-height:200px">
                        <mat-card-title>
                            {{data.name}}
                        </mat-card-title>
                        <mat-card-content>
                            {{data.bio}}
                        </mat-card-content>
                        <mat-card-actions>
                            <div class="row">
                                <div class="col">
                                        <button class="btn btn-success " (click)='sendNotification(data.id)' >
                                                send Notification
                                              </button>
                                </div>
                                <div class="col">
                                        <button class="btn btn-success3 " (click)='viewProfile(data.id)' >
                                                View Pets
                                              </button>
                                    </div>
                            </div>

                        </mat-card-actions>
                      </mat-card>

          </div>
      </div>

    </div>
  <div style="margin-top:2%;margin-left:2%;margin-bottom:2%" *ngIf="showadddiv">
          <form  [formGroup]="registerform">

              <div class="form-group">
                  <label floating for="Name" style="font-size: 20px">Name</label>
              <input type="text" style="font-size: 20px" type="text" name="name" id="name" [(ngModel)]="registerform.name" class="form-control" formControlName="name" required>
              </div>
              <div *ngIf="( registerform.get('name').hasError('required') ) && registerform.get('name').touched">

              <div class="error" style="color:red;font-size:15px" *ngIf="registerform.get('name').hasError('required') && registerform.get('name').touched">
                  Customer name is required
              </div>
              </div>
            <div class="form-group">
              <label for="email" floating style="font-size: 20px"  >Email</label>
          <input type="text" style="font-size: 20px" type="text" name="email" id="email"  [(ngModel)]="registerform.email" class="form-control" formControlName="email" required>
            </div>
          <div *ngIf="( registerform.get('email').hasError('required') || registerform.get('email').hasError('pattern') ) && registerform.get('email').touched">

          <div class="error" style="color:red;font-size:15px" *ngIf="registerform.get('email').hasError('required') && registerform.get('email').touched">
              Email is required
          </div>
          <div class="error" style="color:red;font-size:15px" *ngIf="registerform.get('email').hasError('pattern') && registerform.get('email').touched">
              Enter Correct Email Id
          </div>
          </div>
          <div class="form-group">
              <label for="email" floating style="font-size: 20px"  >Contact No</label>
              <input type="text" style="font-size: 20px" type="text" name="mobile" id="mobile"  [(ngModel)]="registerform.mobile" class="form-control" formControlName="mobile" required>
          </div>
              <div *ngIf="( registerform.get('mobile').hasError('required') || registerform.get('mobile').hasError('minlength') ) && registerform.get('mobile').touched">

              <div class="error" style="color:red;font-size:15px" *ngIf="registerform.get('mobile').hasError('required') && registerform.get('mobile').touched">
                  Contact no  is required
              </div>
              <div class="error" style="color:red;font-size:15px" *ngIf="registerform.get('mobile').hasError('minlength') && registerform.get('mobile').touched">
                  Enter Correct Mobile no
              </div>
              </div>
         <div class="row">
             <div class="col-6"  text-center>
                    <button class="btn btn-success3 btn-block" type="submit" medium (click)="onRegister()"  [disabled]="!registerform.valid">Register </button>
             </div>
             <div class="col-6" text-center>
                    <button class="btn btn-success btn-block" (click)="AddExistingUser()" >Cancel</button>
            </div>
         </div>
          </form>
  </div>
